export default __webpack_public_path__ + "static/media/_B.95aa59aa.png";